module.exports = __webpack_public_path__ + "static/media/prototype_loading_ie.9c238144.png";